import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["prefixCls", "size", "disabled", "loading", "className"];
import classNames from "classnames";
import RcSwitch from "rc-switch";
import * as React from "react";
import { ConfigContext } from "../../ConfigProvider";
import DisabledContext from "../../ConfigProvider/DisabledContext";
import SizeContext from "../../ConfigProvider/SizeContext";
import warning from "../../hack/_util/warning";
import { IconLoading } from "../../Icons/IconLoading";
import { jsx as _jsx } from "react/jsx-runtime";
var Switch = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames;
  var customizePrefixCls = _ref.prefixCls,
    customizeSize = _ref.size,
    customDisabled = _ref.disabled,
    loading = _ref.loading,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    props = _objectWithoutProperties(_ref, _excluded);
  warning("checked" in props || !("value" in props), "Switch", "`value` is not a valid prop, do you mean `checked`?");
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    direction = _React$useContext.direction;
  var size = React.useContext(SizeContext);

  // ===================== Disabled =====================
  var disabled = React.useContext(DisabledContext);
  var mergedDisabled = customDisabled || disabled || loading;
  var prefixCls = getPrefixCls("switch", customizePrefixCls);
  var loadingIcon = /*#__PURE__*/_jsx("div", {
    className: "".concat(prefixCls, "-handle"),
    children: loading && /*#__PURE__*/_jsx(IconLoading, {
      spin: true,
      className: "".concat(prefixCls, "-loading-icon")
    })
  });
  var classes = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-small"), (customizeSize || size) === "small"), _defineProperty(_classNames, "".concat(prefixCls, "-middle"), (customizeSize || size) === "middle"), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _defineProperty(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
  return (
    /*#__PURE__*/
    // @ts-ignore
    _jsx(RcSwitch, _objectSpread(_objectSpread({}, props), {}, {
      prefixCls: prefixCls,
      className: classes,
      disabled: mergedDisabled,
      ref: ref,
      loadingIcon: loadingIcon
    }))
  );
});
Switch.__PI_SWITCH = true;
// @ts-ignore
if (process.env.NODE_ENV !== "production") {
  Switch.displayName = "Switch";
}
export default Switch;